module.exports = __webpack_public_path__ + "img/212.558389a4.png";